<template>
  <div class="container my-5">
    <h3>{{ t('construction.title') }}</h3>

    <div class="d-flex flex-wrap gap-2 mb-3">
      <div
        class="border rounded px-3 py-2 me-2 mb-2 bg-light shadow-sm"
        v-for="district in districts"
        :key="district.value"
      >
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            :id="district.value"
            :value="district.value"
            v-model="selectedDistricts"
          />
          <label class="form-check-label" :for="district.value">
            {{ t(`construction.districts.${district.value}`) }}
          </label>
        </div>
      </div>
    </div>
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend
} from 'chart.js'

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Tooltip, Legend)

const { t } = useI18n()

const chartCanvas = ref(null)
let chartInstance = null

const districts = [
  { value: 'Alanya' },
  { value: 'Konyaalti' },
  { value: 'Kemer' },
  { value: 'Kepez' },
  { value: 'Dosemealti' },
  { value: 'Finike' }
]

const selectedDistricts = ref(['Alanya'])
const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#6610f2', '#17a2b8']

const fetchData = async () => {
  try {
    const response = await axios.get('/api/v1/statistics/construction/antalya')
    const data = response.data

    const labels = data.map(entry => entry.Year)
    const datasets = selectedDistricts.value.map((district, index) => ({
      label: t(`construction.districts.${district}`),
      data: data.map(entry => entry.Permits[district] || 0),
      borderWidth: 2,
      borderColor: colors[index % colors.length],
      pointRadius: 2,
      fill: false
    }))

    if (chartInstance) {
      chartInstance.data.labels = labels
      chartInstance.data.datasets = datasets
      chartInstance.update()
    } else {
      chartInstance = new Chart(chartCanvas.value, {
        type: 'line',
        data: {
          labels,
          datasets
        },
        options: {
          responsive: true,
          plugins: {
            title: { display: false },
            legend: { display: true }
          },
          scales: {
            x: { title: { display: true, text: t('construction.x_axis') } },
            y: { title: { display: true, text: t('construction.y_axis') } }
          }
        }
      })
    }
  } catch (error) {
    console.error('Ошибка при загрузке данных:', error)
  }
}

onMounted(fetchData)
watch(selectedDistricts, fetchData)
</script>
